import type { AxiosResponse } from 'axios';
import api from './api';

interface MonthlyReportResponse {
  report: unknown[];
  [key: string]: unknown;
}

export const getMonthlyReport = async (startDate: string, endDate: string): Promise<MonthlyReportResponse> => {
  try {
    const response: AxiosResponse<MonthlyReportResponse> = await api.get(`/business/monthly-report`, { params: { startDate, endDate } });
    console.log('Fetched salon owner finance report:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching monthly report:', error);
    throw error;
  }
};
